import React from "react";
import { Tooltip } from "react-tippy";
import { ParseDate, ParseDateTime } from "../../../../../../../helpers/Parsers";
import OrderPills from "../../../../../atoms/Pills/OrderPills";
import styles from "./TableItem.module.scss";
import i18n from "i18n";

const tooltipStyle = {
  background: "#FFFFFF",
  boxShadow: "0px 3px 6px #00000029",
  height: "45px",
  padding: "0 15px",
  color: "#494F66",
  fontFamily: "Roboto-Light",
  fontSize: "18px",
  borderRadius: "15px",
  display: "flex",
  alignItems: "center"
};

const mapping = {
  DRA: i18n.t("orders.status.DRA"),
  PEN: i18n.t("orders.status.PEN"),
  PRO: i18n.t("in.progress"),
  SUP: i18n.t("orders.status.SUP"),
  DISP: i18n.t("orders.status.DISP"),
  REJ: i18n.t("orders.status.REJ"),
  COM: i18n.t("orders.status.COM"),
};

export const RelocationOrderTableItem = ({ relocationOrder, handleClick }) => {
  return (
    <div
      className={styles["order-relocation-table-item-container"]}
      data-automation-id="product-item"
      data-relocation-order-id={relocationOrder.id}
      onClick={handleClick}
    >
      <div className={styles["table-item-code"]}>
        <Tooltip
          html={<div style={tooltipStyle}>{relocationOrder.code}</div>}
          title={relocationOrder.code}
          followCursor={true}
          position="left"
          offset={25}
        >
          <p>{relocationOrder.code}</p>
        </Tooltip>
      </div>
      <div className={styles["table-item-date"]}>
        <Tooltip
          html={
            <div style={tooltipStyle}>
              {relocationOrder.created_at
                ? ParseDateTime(relocationOrder.created_at)
                : null}
            </div>
          }
          followCursor={true}
          position="right"
          offset={25}
        >
          {" "}
          <p>
            {relocationOrder.created_at
              ? ParseDate(relocationOrder.created_at)
              : "-"}
          </p>
        </Tooltip>
      </div>
      <div className={styles["table-item-owner"]}>
        <Tooltip
          html={
            <div style={tooltipStyle}>
              <p>
                {relocationOrder.owner
                  ? `${relocationOrder.owner.first_name} ${relocationOrder.owner.last_name}`
                  : "-"}
              </p>
            </div>
          }
          followCursor={true}
          position="right"
          offset={25}
        >
          <p>
            {relocationOrder.owner
              ? `${relocationOrder.owner.first_name} ${relocationOrder.owner.last_name}`
              : "-"}
          </p>
        </Tooltip>
      </div>
      <div className={styles["table-item-state"]}>
        <div className={styles["state-wrapper"]}>
          <Tooltip
            html={
              <div style={tooltipStyle}>
                <p>{mapping[relocationOrder.status]}</p>
              </div>
            }
            followCursor={true}
            position="right"
            offset={25}
          >
            <OrderPills state={relocationOrder.status} />
          </Tooltip>
        </div>
      </div>
      <div
        className={styles["table-item-button"]}
        data-automation-id="select-relocationOrder"
      >
        <i className="icon-chevron-derecha"></i>
      </div>
    </div>
  );
};

export default RelocationOrderTableItem;
